export enum WorkspaceWorkflowQueryParam {
    AddExcludeProducts = 'add_exclude_products',
    CustomLabels = 'custom_labels',
    PromotionManagement = 'promotion_management',
    AbTesting = 'ab_testing'
}

export enum AddExcludeProductsQueryParam {
    RuleId = 'rule_id',
    Tab = 'tab'
}

export enum CustomLabelsQueryParam {
    RuleId = 'rule_id',
    Tab = 'tab'
}
